<template>
  <div id="carouselBox">
    <el-carousel :height="initHeight">
      <el-carousel-item v-for="(item, index) in carouselImgs" :key="index">
        <img :src="item" alt="找不到图片" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  mounted () {
    this.loadCarouselImages(2, 10) // 开始从数据库读取图片
  },
  data () {
    return {
      carouselImgs: [],
      initHeight: '0px'
    }
  },
  methods: {
    loadCarouselImages (typeName, count) {
      const api = '/md/front/news/getItemsByTypeId'
      const params = {
        typeId: typeName,
        num: count
      }
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status !== 200) {
          return
        }
        const resMap = res.data
        let str
        let p1, p2
        const cacheImgs = []
        if (resMap != null) {
          const pipilu = resMap
          for (var ite in pipilu) {
            str = pipilu[ite].newsContent
            p1 = str.indexOf('"')
            if (p1 > 0) {
              p1++
              p2 = str.indexOf('"', p1 + 20)
              if (p2 > p1) {
                str = str.substring(p1, p2)
                cacheImgs.push(str)
              }
            }
          }
          this.initHeight = '300px'
        } else {
          this.initHeight = '0px'
        }
        this.carouselImgs = cacheImgs
      })
    }
  }
}
</script>
<style scoped>
#carouselBox img {
  width: 100%;
}
</style>
